<template>
  <div class="container">
    <FormGenerator :config_file="config_file"> </FormGenerator>
  </div>
</template>

<script>
import FormGenerator from "@/components/FormGenerator.vue";

export default {
  name: "Bankruptcy",
  components: {
    FormGenerator
  },
  data() {
    return {
      config_file: "/forms_configuration/bankruptcy/config.json"
    };
  }
};
</script>
